import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // Initialize the fbq function if it doesn't exist
    // @ts-ignore
    if (!window.fbq) {
      // @ts-ignore
      window.fbq = function () {
        // @ts-ignore
        window.fbq.callMethod ?
        // @ts-ignore
        window.fbq.callMethod.apply(window.fbq, arguments) :
        // @ts-ignore
        window.fbq.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = window.fbq;
      // @ts-ignore
      window.fbq.push = window.fbq;
      // @ts-ignore
      window.fbq.loaded = true;
      // @ts-ignore
      window.fbq.version = '2.0';
      // @ts-ignore
      window.fbq.queue = [];
    }
    // Safely inject the script into the head instead of looking for existing scripts
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize and track
    // @ts-ignore
    window.fbq('init', '1020593689919540');
    // @ts-ignore
    window.fbq('track', 'PageView');
  }, []);
  return null;
}